import React from 'react'
import { Link } from 'react-router-dom';


const Card = (props) => {
    const { image, header, description, link, backgroundImage, linkPath } = props;
    return (
        <div className='container wrapper-container' style={{ backgroundImage: `url(${backgroundImage})` }}>
            <div className='header-container'>
                <img src={image} alt="headerIcon" />
                <div className='text-content'>{header}</div>
            </div>
            <div className='text-content mb-2'>{description}</div>
            <div className='link-content'>
                <Link to={linkPath}>{link}</Link>
            </div>
        </div>
    )
}

export default Card;